import StartButton from './component.styles'
export default StartButton
